import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router'
import { adminSubscriptions } from '../../../core/controllers/Admin/AdminSubscriptions'

export default class SubscriptionTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subscriptionsData: null
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        adminSubscriptions.getSubscriptions(function(response){
            self.setState({
                subscriptionsData: response.data
            })
        })
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatCreatedDate(cell, row) {
        return moment.utc(row.created_at).local().format('MMM Do YYYY, h:mm a');
    }

    formatUpdatedDate(cell, row) {
        return moment.utc(row.updated_at).local().format('MMM Do YYYY, h:mm a');
    }

    formatPrice(cell, row) {
        return "$" + row.price / 100;
    }

    didSelectRow(row) {
        browserHistory.push('/admin/subscription/' + row.subscription_id);
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    render(){
        var self = this;
        var subscriptionsData = this.state.subscriptionsData;

        if (subscriptionsData !== null) {
            subscriptionsData = this.state.subscriptionsData.map(function(sub) {
                return self.flattenObject(sub);
            });
        }

        const options = {
            onRowClick: this.didSelectRow
        };


        return (
            <div class="content">
                {subscriptionsData != null ? (
                    <BootstrapTable data={subscriptionsData} options={options} version='4' striped search pagination>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='name' dataSort={ true }>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='price' dataFormat={this.formatPrice} dataSort={ true }>Price</TableHeaderColumn>
                        <TableHeaderColumn dataField='created_at' dataFormat={this.formatCreatedDate} dataSort={ true }>Date Created</TableHeaderColumn>
                        <TableHeaderColumn dataField='updated_at' dataFormat={this.formatUpdatedDate} dataSort={ true }>Last Updated</TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <p>No subscriptions found.</p>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Subscriptions/SubscriptionTable.jsx